<template>
  <b-modal
    scrollable
    no-fade
    ok-only
    ok-title="Asignar"
    title="Asignar confirmación"
    static
    id="modal-assign-supplier-confirmation-view"
    size="md"
    body-class="position-static"
    @ok="onSubmit"
  >
    <b-row>
      <div class="col-12">
        <p class="mb-0">{{rowsMessage}}</p>
      </div>
      <b-form-group class="col-12" label="Confirmado">
        <b-form-select size="sm" v-model="confirmation" :options="options" required />
      </b-form-group>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  methods: {
    onSubmit(event) {
      if (this.confirmation == null) {
        event.preventDefault();
        this.$root.showAlert("No hay estado seleccionado", {
          variant: "warning",
        });
        return;
      }
      let aux = {
        ids: this.selected,
        confirmation: this.confirmation,
      };
      this.$root.api
        .post(`/transport-services/massive-update-supplier-confirmation`, aux)
        .then(() => {
          this.$root.showAlert("Actualización exitosa");
          this.$root.$emit("bv::refresh::table", "reservations-index-list");
          this.$emit('update:selected',[])
        })
        .catch((err) => {
          this.$root.handleRequestError(err);
        });
    },
  },
  props: {
    selected: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      confirmation: "pending",
    };
  },
  computed: {
	options(){
		return this.$root.auxVars.supplierConfirmationOpts;
	},
    rowsMessage() {
      return (
        "Ha seleccionado " +
        this.selected.length +
        " registros para actualizar."
      );
    },
  },
  mounted() {},
  watch: {},
};
</script>
